import { Controller } from '@hotwired/stimulus'
import { getPath, removeQuery } from '../utils/url_helpers'

export default class extends Controller {
  static targets = ['item']
  static outlets = ['kaia--accordion-component']

  itemTargetConnected(element) {
    if (this.activeItems.includes(element)) element.dataset.active = true
  }

  kaiaAccordionComponentOutletConnected(outlet, element) {
    if (element.classList.contains('favorite-menu')) return // we don't want to open the favorite menu by default

    this.activeItems.forEach((activeItem) => {
      if (element.contains(activeItem)) return outlet.open()
    })
  }

  itemTargetDisconnected(element) {
    this._activeItems = undefined // remove so it can be re-calculated on connect
  }

  kaiaAccordionComponentOutletDisconnected(outlet, element) {
    this._activeItems = undefined // remove so it can be re-calculated on connect
  }

  get activeItems() {
    if (this._activeItems) return this._activeItems

    const currentPath = getPath().replace(/\/+/g, '/').replace(/\/$/g, '')
    const activeItems = []

    for (const item of this.itemTargets) {
      const href = item.querySelector('a').getAttribute('href')
      if (!href) continue

      if (currentPath === removeQuery(href)) {
        activeItems.push(item)
      }
    }

    return (this._activeItems = activeItems)
  }
}
